import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService } from '@org/shared-services';
import { MorningMeetingService } from '@org/shared-services';
import { BehaviorSubject, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReminderService {
  private overlayVisibleSubject = new BehaviorSubject<boolean>(false);
  overlayVisible$ = this.overlayVisibleSubject.asObservable();
  private reminderTime!: Date;
  private endReminderTime!: Date;
  private isTesting: boolean = false; // Set this to false for production

  constructor(
    private authService: AuthService,
    private morningMeetingService: MorningMeetingService
  ) {
   // this.reminderTime = new Date(new Date().getTime() + 1 * 60 * 1000); // Set reminder time to one minute from now
    //this.setNextReminder();
   this.setInitialReminderTime(8);
   this.startReminder();
  }

  setInitialReminderTime(hour: number, minute: number = 0): void {
    if (this.isTesting) {
      this.reminderTime = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), hour, minute, 0); // Set reminder time to 7:15 PM for testing
      this.endReminderTime = new Date(this.reminderTime.getTime() + 1 * 60 * 60 * 1000); // End reminder time one hour after the start time
    } else {
      this.setNextReminder(hour, minute); // Set the initial reminder time for production
    }
  }

  startReminder(): void {
    const reminderInterval = interval(60 * 60 *1000); // Check every Hour

    reminderInterval.pipe(
      switchMap(() => this.authService.currentUser)
    ).subscribe(user => {
      if (user && this.isReminderTime() && !this.isSummarySubmitted() && this.isTechRole(user)) {
        this.sendReminder(user);
      }
    });
  }

  isReminderTime(): boolean {
    const now = new Date();
    return now >= this.reminderTime && now <= this.endReminderTime; // Check if the current time is within the reminder window
  }

  // isReminderTime(): boolean {
  //   const now = new Date();
  //   // const day = now.getDay();
  //   // const hour = now.getHours();
  //   return now >= this.reminderTime; // Check if the current time is past the reminder time
  //   // return now.getHours() === 12; // 9 PM
  //   // Check if it's a weekday (Monday to Friday) and between 8 AM and 9 AM
  //   // if (day >= 1 && day <= 5 && hour >= 8 && hour < 9) {
  //   //   return true;
  //   // }
  //   // return false;
  // }

  isSummarySubmitted(): boolean {
    // Implement logic to check if the summary has been submitted
    return false;
  }

  isTechRole(usr: any): boolean {
    const user = JSON.parse(usr);
    return user.roles.includes('tech');
  }

  sendReminder(user: any): void {
    // Implement logic to send reminder notification
    this.showOverlay();
  }

  showOverlay(): void {
    this.overlayVisibleSubject.next(true);
  }

  hideOverlay(): void {
    this.overlayVisibleSubject.next(false);
  }

  // setNextReminder(): void {
  //   const now = new Date();
  //   const nextReminder = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 8, 0, 0); // Set to 8 AM the next day
  //   this.reminderTime = nextReminder;
  //   console.log(`Next reminder set for ${this.reminderTime}`);
  // }

  setNextReminder(hour: number, minute: number = 0): void {
    const now = new Date();
    let nextReminder = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0); // Set to the provided start time today

    // If it's past the provided start time today, set the reminder for the next weekday
    if (now >= nextReminder) {
      nextReminder.setDate(nextReminder.getDate() + 1);
    }

    // Skip weekends
    if (nextReminder.getDay() === 6) { // Saturday
      nextReminder.setDate(nextReminder.getDate() + 2); // Set to Monday
    } else if (nextReminder.getDay() === 0) { // Sunday
      nextReminder.setDate(nextReminder.getDate() + 1); // Set to Monday
    }

    this.reminderTime = nextReminder;
    this.endReminderTime = new Date(this.reminderTime.getTime() + 1 * 60 * 60 * 1000); // End reminder time one hour after the start time
    if (!environment.production) {
      console.debug(`Next reminder set for ${this.reminderTime}`);
    }
  }

}